<template>
  <div>
    <div class="vs-card">
      <header class="vs-card-header">
        <p class="vs-card-header-title">
          {{ "datalink.history" | t }}
        </p>
      </header>
      <div class="vs-card-content">
        <div class="vs-content">
          <VsTable :columns="DATALINK_HISTORY" :dataArray="historyArray" :isLoading="historyTableSetting.isLoading">
            <template v-slot="{ colValue }">
              <component :is="colValue.colInfo.key" :rowData="colValue.data" />
            </template>
          </VsTable>
          <VsPager
            :totalNumber="historyTableSetting.totalNumber"
            :numberOfItemPerPage="historyTableSetting.numberOfItemPerPage"
            :currentPage="historyTableSetting.currentPage"
            :isLoading="historyTableSetting.isLoading"
            :pageUp="pageUp"
            :pageDown="pageDown"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { DATALINK_HISTORY } from "@/misc/tables";

import Control from "./Control";
import FileCount from "./FileCount";
import Status from "./Status";

export default {
  components: {
    Control,
    FileCount,
    Status,
  },
  data() {
    return {
      DATALINK_HISTORY,
    };
  },
  computed: {
    ...mapGetters({
      history: "datalink/historyList",
      historyTableSetting: "datalink/historyTableSetting",
    }),
    historyArray() {
      return this.history.map((record) => {
        return {
          ...record,
          status: this.setStatus(record),
        };
      });
    },
  },
  created() {
    const INTERVAL = 10 * 1000;
    setInterval(this.silentUpdate, INTERVAL);
  },
  methods: {
    ...mapActions("datalink", ["fetchHistory", "changeHistoryPageNumber"]),
    setStatus(fileHistory) {
      if (fileHistory.deleted) {
        return "deleted";
      }
      if (!fileHistory.file_uploaded || fileHistory.file_uploaded === 0) {
        return "initial";
      }
      if (fileHistory.files_total > fileHistory.file_finished) {
        return "inProgress";
      }
      return "done";
    },
    pageUp() {
      this.changeHistoryPageNumber(this.historyTableSetting.currentPage + 1);
    },
    pageDown() {
      this.changeHistoryPageNumber(this.historyTableSetting.currentPage - 1);
    },
    silentUpdate() {
      this.fetchHistory(true);
    },
  },
};
</script>
